import {RequestHandler, RequestOptions} from "./RequestHandler";
import Axios, {CancelTokenSource} from "axios";

export class WPApiPost{
    constructor()
    {


    }

    private static URL:string;
    private static Nounce:string;
    public static ConfigApi(url:string,nounce:string){
        WPApiPost.URL=url;
        WPApiPost.Nounce=nounce;
    }

    public static Post<T=any>(action:string,data:any,options?:RequestOptions)
    {
        if(action[0]=='/')
            action=action.substr(1);
        return new RequestHandler<T>('',data,WPApiPost.URL+action,options).setHeaders({'X-WP-Nonce':WPApiPost.Nounce}).Execute();
    }

    public static async CancellablePost<T>(action:string,data:any={},cancellationToken:CancellationToken,options?:RequestOptions)
    {
        if(action[0]=='/')
            action=action.substr(1);
        return new RequestHandler<T>('',data,WPApiPost.URL+action,options).setHeaders({'X-WP-Nonce':WPApiPost.Nounce}).ExecuteWithCancellation(cancellationToken);

    }
}




export class CancellationToken{
    public source:CancelTokenSource;

    constructor(){
        this.source=Axios.CancelToken.source();
    }
    public Cancel(){
        this.source.cancel();
    }


}

export interface CancellabeResult<T>{
    wasCancelled:boolean;
    result:T;
}